import cart from "./cart.json";
import checkout from "./checkout.json";
import common from "./common.json";
import confirmation from "./confirmation.json";
import errors from "./errors.json";
import login from "./login.json";
import pausescreen from "./pausescreen.json";
import pagetitles from "./pagetitles.json";
import payment from "./payment.json";
import precheckout from "./precheckout.json";
import products from "./products.json";

export const da = {
  cart,
  checkout,
  common,
  confirmation,
  errors,
  login,
  pausescreen,
  pagetitles,
  payment,
  precheckout,
  products,
};
